// API Configuration
// В dev режиме используем пустую строку для работы с proxy из vite.config.js
// В production ОБЯЗАТЕЛЬНО требуем VITE_API_BASE_URL в environment variables

const API_BASE_URL = import.meta.env.DEV
  ? ''
  : import.meta.env.VITE_API_BASE_URL;

// Validate in production
if (!import.meta.env.DEV && !API_BASE_URL) {
  throw new Error(
    'VITE_API_BASE_URL environment variable must be set in production. ' +
    'Please configure it in your deployment settings.'
  );
}

export { API_BASE_URL };

